var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { DomSanitizer } from '@angular/platform-browser';
var ChatbotComponent = /** @class */ (function () {
    function ChatbotComponent(router, util, api, sanitizer) {
        this.router = router;
        this.util = util;
        this.api = api;
        this.sanitizer = sanitizer;
    }
    ChatbotComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, chatbotConfig;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        _a = this;
                        return [4 /*yield*/, this.api.get("master", "configuration")];
                    case 1:
                        _a.config = _b.sent();
                        if (this.config == null || this.config.length == 0) {
                        }
                        chatbotConfig = this.config.filter(function (c) {
                            return c.dpa_name.toUpperCase() == "CHATBOT";
                        });
                        if (chatbotConfig == null || chatbotConfig.length == 0) {
                            this.util.ErrorDialog("ไม่สามารถดึงค่า Config ได้ กรุณาติดต่อเจ้าหน้าที่");
                        }
                        else {
                            this.urlString = chatbotConfig[0].dpa_value;
                            this.chatbotUrl = this.sanitizer.bypassSecurityTrustResourceUrl(chatbotConfig[0].dpa_value);
                        }
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatbotComponent.prototype.newContact = function (event) {
        var url = this.util.baseUrl() + "/newCaseChatbot";
        window.open(url, '_blank');
    };
    ChatbotComponent.prototype.newTab = function () {
        window.open(this.urlString, '_blank');
    };
    return ChatbotComponent;
}());
export { ChatbotComponent };



// WEBPACK FOOTER //
// ./src/app/chatbot/chatbot.component.ts.pre-build-optimizer.js